import { Controller } from "@hotwired/stimulus"

// Кнопки привязки менеджеров к U-ON: точечная в форме пользователя и массовая
// в списке. Логика запроса, спиннера и вывода ошибки общая — отличаются только
// адрес и то, что происходит после успешного ответа.
export default class extends Controller {
  static targets = ["button", "input", "message"]
  static values = { url: String, bulkUrl: String }

  link(event) {
    event.preventDefault()

    this.#request(this.urlValue, (data) => {
      if (this.hasInputTarget && data.uon_manager_id) {
        this.inputTarget.value = data.uon_manager_id
      }
      this.#showMessage("Менеджер найден и связан", "text-success")
    })
  }

  linkAll(event) {
    event.preventDefault()

    this.#request(this.bulkUrlValue, (data) => {
      this.#showMessage(`Проверено: ${data.checked}, связано: ${data.matched}`, "text-success")
      if (data.matched > 0) window.location.reload()
    })
  }

  async #request(url, onSuccess) {
    if (!url) return

    this.#setBusy(true)
    this.#showMessage("", "")

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        }
      })

      const data = await response.json().catch(() => ({}))

      if (!response.ok) {
        throw new Error(data.error || "Не удалось связать с U-ON")
      }

      onSuccess(data)
    } catch (error) {
      this.#showMessage(error.message, "text-danger")
    } finally {
      this.#setBusy(false)
    }
  }

  #setBusy(busy) {
    if (!this.hasButtonTarget) return

    this.buttonTarget.dataset.originalText ||= this.buttonTarget.textContent.trim()
    this.buttonTarget.disabled = busy
    this.buttonTarget.textContent = busy ? "Связываем…" : this.buttonTarget.dataset.originalText
  }

  #showMessage(text, className) {
    if (!this.hasMessageTarget) return

    this.messageTarget.textContent = text
    this.messageTarget.className = `small mt-1 ${className}`
  }
}
